import { Route, Routes } from 'react-router-dom';
import * as PATHS from './CONSTANTS';
import Login from '../pages/auth/login/index'
import Resources from '../pages/resources';
import Positions from '../pages/positions';
import Registration from '../pages/auth/registration';
import Verification from '../pages/verification';
import AppliedCandidates from '../pages/positionDetails';
import ForgotPassword from '../pages/auth/forgotPassword';
import ResetPassword from '../pages/auth/resetPassword';
import ApplyPositions from '../pages/applyPositions';
import CompanySettings from '../pages/companySettings';
import CreateResource from '../pages/createResources';
import IncontractResources from '../pages/incontractResources';
import Timesheet from '../pages/timesheet/index';
import AddTimesheet from '../pages/timesheet/addTimesheet';
import ApplyResource from '../pages/applyResource';

const RouterConfig = () => {
    return (
        <Routes>
            <Route path={PATHS.RESOURCES} element={<Resources/>} />
            <Route path={PATHS.POSITIONS} element={<Positions />} />
            <Route path={PATHS.REGISTRATION1} element={<Registration/>} />
            <Route path={PATHS.REGISTRATION} element={<Registration/>} />
            <Route path={PATHS.LOGIN} element={<Login />} />  
            <Route path={PATHS.FORGOTPASSWORD} element={<ForgotPassword/>} />
            <Route path={PATHS.RESETPASSWORD} element={<ResetPassword/>} />
            <Route path={PATHS.VERIFICATION} element={<Verification />} />
            <Route path={PATHS.APPLIEDCANDIDATES} element={<AppliedCandidates />} />
            <Route path={PATHS.APPLYPOSITION} element={<ApplyPositions />} />
            <Route path={PATHS.CREATERESOURCES} element={<CreateResource/>} />
            <Route path={PATHS.COMPANYSETTINGS} element={<CompanySettings />} />
            <Route path={PATHS.INCONTRACTRESOURCES} element={<IncontractResources />} />
            <Route path={PATHS.TIMESHEET} element={<Timesheet />} />
            <Route path={PATHS.ADDTIMESHEET} element={<AddTimesheet />} />
            <Route path={PATHS.APPLYRESOURCE} element={<ApplyResource/>} />
        </Routes>
    )
}

export default RouterConfig;